module.exports = __webpack_public_path__ + "img/loader.5ce78eb5.gif";